import axios from "axios";

export const feedFactoryAxios = axios.create({
  baseURL: "/api",
});
